
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"73","height":"73","viewBox":"0 0 73 73"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"play","transform":"translate(-8682 1022.797)"}},[_c('ellipse',{attrs:{"stroke":"#ffffff","stroke-width":"2","id":"Ellipse_8","data-name":"Ellipse 8","cx":"36.5","cy":"36.5","rx":"36.5","ry":"36.5","transform":"translate(8682 -1022.797)","fill":"#0aff00"}}),_c('path',{attrs:{"id":"Path_5095","data-name":"Path 5095","d":"M248,3596l23.684,15.55L248,3627.1Z","transform":"translate(8464.314 -4597.957)","fill":"#00203a"}})])])
          )
        }
      }
    